// SPDX-License-Identifier: AGPL-3.0-or-later

import {SettingsSection} from '@app/features/app/components/dialogs/shared/SettingsSection';
import {VideoTab} from '@app/features/user/components/modals/tabs/VideoTab';
import {VoiceTab} from '@app/features/user/components/modals/tabs/VoiceTab';
import styles from '@app/features/user/components/modals/tabs/voice_video_tab/Inline.module.css';
import {VoiceDiagnosticsSection} from '@app/features/user/components/modals/tabs/voice_video_tab/VoiceDiagnosticsSection';
import Users from '@app/features/user/state/Users';
import VoiceSettings from '@app/features/voice/state/VoiceSettings';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';
import {useMemo} from 'react';
export const VoiceVideoInlineContent: React.FC = observer(() => {
	const {t} = useLingui();
	const user = Users.currentUser;
	const voiceSettings = VoiceSettings;
	const hasPremium = useMemo(() => user?.isPremium() ?? false, [user]);
	return (
		<div className={styles.container}>
			<SettingsSection id="audio" title={t`Audio`}>
				<VoiceTab voiceSettings={voiceSettings} hasPremium={hasPremium} autoRequestPermission={false} />
			</SettingsSection>
			<SettingsSection id="video" title={t`Video`}>
				<VideoTab voiceSettings={voiceSettings} hasPremium={hasPremium} autoRequestPermission={false} />
			</SettingsSection>
			<SettingsSection
				id="diagnostics"
				title={t`Diagnostics`}
				description={t`Upload a voice diagnostics bundle for troubleshooting audio, video, and screen sharing issues.`}
			>
				<VoiceDiagnosticsSection />
			</SettingsSection>
		</div>
	);
});
